exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-height{margin-bottom:1.8rem}.mythick{margin-bottom:0!important}.mytitle{float:right;padding-right:1rem}.myfield{background:#f8f8f8}.goPay{height:1.8rem;background-color:#fff;width:100%;font-size:.9rem;line-height:1.8rem;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e97c0d8","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/mypay/MypayDetail.vue
// module id = 476
// module chunks = 0